const UTM_STORAGE_KEY = "nil_beauty_utm";

export interface UTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}

export const captureUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utm: UTMParams = {};
  const keys: (keyof UTMParams)[] = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

  let hasAny = false;
  for (const key of keys) {
    const val = params.get(key);
    if (val) {
      utm[key] = val.slice(0, 200);
      hasAny = true;
    }
  }

  if (hasAny) {
    try {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm));
    } catch {}
  }
};

export const getStoredUTM = (): UTMParams => {
  try {
    const raw = sessionStorage.getItem(UTM_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};
